import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { LogoutComponent } from './pages/logout/logout.component';
import { UssDashboardLandingComponent } from './pages/uss-dashboard-landing/uss-dashboard-landing.component';

const routes: Routes = [
  {
    path: '',
    component: UssDashboardLandingComponent,
    canActivate: [MsalGuard],
    data: { title: 'My Cloud Security Project Management' },
  },
  { 
    path: 'logout', 
    component: LogoutComponent 
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
